import {
  Box,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useFormikContext } from 'formik';
import { useEffect, useRef } from 'react';
import {
  AppFormikCheckbox,
  AppFormikSelect,
  AppFormikTextArea,
  AppFormikTextField,
} from 'shared/components/AppComponents';

interface BasicInformationFormProps {
  test: any;
}

export const basicRefField = [
  'title',
  'duration',
  'description',
  'format',
  'status',
  'mandatory',
];

const BasicInformationForm: React.FC<BasicInformationFormProps> = () => {
  const basicInformationRef = useRef<HTMLDivElement | null>(null);
  const theme = useTheme();
  const match = useMediaQuery(theme.breakpoints.down('md'));
  const { errors, submitCount } = useFormikContext<any>();

  useEffect(() => {
    console.log(submitCount);
    if (submitCount === 0) return;
    if (!errors || Object.keys(errors).length === 0) return;

    const basicInformationError = basicRefField.some(
      (field: string) => errors?.[field]
    );

    if (basicInformationError) {
      basicInformationRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [errors, submitCount]);

  return (
    <Paper
      variant="outlined"
      className="basic-information-form"
      ref={basicInformationRef}
    >
      <Typography variant="h6">Basic Information</Typography>
      <Stack direction={match ? 'column' : 'row'} spacing={2}>
        <Box className="basic-information-title">
          <AppFormikTextField
            name="title"
            placeholder="Executive Leadership & Board Training "
            outerLabel
            label="Title *"
          />
        </Box>
        <Box className="basic-information-duration">
          <AppFormikTextField
            name="duration"
            placeholder="25"
            outerLabel
            label="Duration (minutes)"
            type="number"
          />
        </Box>
      </Stack>
      <Box className="basic-information-description">
        <AppFormikTextArea
          name="description"
          placeholder="Brief description of the training program"
          label="Description"
          outerLabel
        />
      </Box>
      <Stack direction={match ? 'column' : 'row'} spacing={2}>
        <Box className="basic-information-likelihood">
          <AppFormikSelect
            name="format"
            className="rework-selection"
            notched={false}
            labelId="fix-selection-label"
            testid="solicitor-dropdown"
            MenuProps={{
              className: 'menu-fix-selection single-fix-rework',
            }}
            outerLabel
            placeholder="Select format"
            notEmphasized
            notSelectablePlaceholder
            label="Format"
            items={['Online', 'Offline']}
          />
        </Box>
        <Box className="basic-information-impact">
          <AppFormikSelect
            name="status"
            className="rework-selection"
            notched={false}
            labelId="fix-selection-label"
            testid="solicitor-dropdown"
            MenuProps={{
              className: 'menu-fix-selection single-fix-rework',
            }}
            outerLabel
            placeholder="Select status"
            notEmphasized
            notSelectablePlaceholder
            label="Status"
            items={['Published', 'Draft', 'Archived']}
          />
        </Box>
      </Stack>
      <Box className="basic-information-checkbox" mt={4}>
        <AppFormikCheckbox
          name="mandatory"
          label="This training is mandatory"
          outerLabel=""
        />
      </Box>
    </Paper>
  );
};

export default BasicInformationForm;
